// extracted by mini-css-extract-plugin
export default {"wrapper":"AjiLMxOtCrJ3UATAtEu+FA=="};